import EmbedMode from "discourse/lib/embed-mode";
import { withPluginApi } from "discourse/lib/plugin-api";

export const COMMUNITY_LOBBY_PATH = "/chat/c/community-lobby/3";

const COMMUNITY_LOBBY_ROUTE_MODELS = ["community-lobby", 3];
const LEGACY_GENERAL_CHANNEL_ID = 2;

function hasNoJoinedPublicChannels(
  currentUser,
  chatChannelsManager,
  hasPreloadedChannels
) {
  return Boolean(
    currentUser &&
      hasPreloadedChannels &&
      chatChannelsManager.publicMessageChannels?.length === 0
  );
}

export function isLegacyGeneralChatUrl(url, chatChannelsManager) {
  if (!url || url === "/chat" || url === "/chat/") {
    return true;
  }

  let decoded = url;
  try {
    decoded = decodeURIComponent(url);
  } catch {
    decoded = url;
  }

  if (decoded.includes("/常规/")) {
    return true;
  }

  const channels = chatChannelsManager?.publicMessageChannels || [];
  const general = channels.find(
    (channel) =>
      Number(channel.id) === LEGACY_GENERAL_CHANNEL_ID ||
      channel.slug === "general" ||
      channel.title === "常规" ||
      channel.name === "常规"
  );
  const generalId = general?.id ?? LEGACY_GENERAL_CHANNEL_ID;

  return new RegExp(`/chat/c/(?:[^/]+/)?${generalId}(?:/|$)`).test(url);
}

function shouldOpenCommunityLobby(
  currentUser,
  chatChannelsManager,
  hasPreloadedChannels,
  url
) {
  return (
    hasNoJoinedPublicChannels(
      currentUser,
      chatChannelsManager,
      hasPreloadedChannels
    ) || isLegacyGeneralChatUrl(url, chatChannelsManager)
  );
}

export function registerCommunityChatDefaults(api) {
  api.modifyClass(
    "service:chat-state-manager",
    (Superclass) =>
      class extends Superclass {
        get isDrawerPreferred() {
          return !this.hasNoPreferredMode && super.isDrawerPreferred;
        }

        get lastKnownChatURL() {
          const url = super.lastKnownChatURL;
          if (
            shouldOpenCommunityLobby(
              this.currentUser,
              this.chatChannelsManager,
              this.hasPreloadedChannels,
              url
            )
          ) {
            return COMMUNITY_LOBBY_PATH;
          }

          return url;
        }
      },
    { ignoreMissing: true }
  );

  api.modifyClass(
    "route:chat.index",
    (Superclass) =>
      class extends Superclass {
        async redirect(...args) {
          const lastKnown = this.chatStateManager.lastKnownChatURL;
          // lastKnownChatURL may already be remapped to the lobby. Still
          // replaceWith it — core chat.index can ignore that URL and reopen 常规.
          if (
            lastKnown === COMMUNITY_LOBBY_PATH ||
            shouldOpenCommunityLobby(
              this.currentUser,
              this.chatChannelsManager,
              this.chatStateManager.hasPreloadedChannels,
              lastKnown
            )
          ) {
            return this.router.replaceWith(
              "chat.channel",
              ...COMMUNITY_LOBBY_ROUTE_MODELS
            );
          }

          return await super.redirect(...args);
        }
      },
    { ignoreMissing: true }
  );
}

export default {
  name: "community-navigation-chat-default",
  before: "inject-discourse-objects",

  initialize(container) {
    const siteSettings = container.lookup("service:site-settings");
    if (!siteSettings.community_navigation_enabled || EmbedMode.enabled) {
      return;
    }

    withPluginApi(registerCommunityChatDefaults);
  },
};
